<template>
  <div class="container">
    <div class="top_box">
      <div class="top_title">
        <div class="top_one">
          <!-- <div class="top_one" v-if="info.flow.status!='不予受理'&&baseList.status!=150"> -->
          <step :stepArray="stepArray" :currentVal="currentVal"></step>
          <!-- <div
            class="tip_tool"
            :class="{'tip_one':currentVal==1,'tip_two':currentVal==2
                  ,'tip_three':currentVal==3||currentVal==4,'tip_five':currentVal==5}"
          >
            <span @click="callPhone">
              <img src="../../../../assets/image/icon_person.png" class="icon_person" />
              处置部门：{{baseList.centerName}}
            </span>
            <span>
            处置部门:无虎丘区中水中心内发发生车上的发生的发生</span>
            <div
              class="jiao"
              :class="{'jiao_active1':currentVal==3,'jiao_active2':currentVal==4,'jiao_active3':currentVal==5}"
            ></div>
          </div>-->
        </div>
        <!-- <div class="top_reject" v-if="baseList.statusText==='不予受理'">
          <div class="reject_one">
            <span>处置部门</span>
            <span>{{baseList.centerName}}</span>
          </div>
          <div class="reject_one" style="border:none;">
            <span>处置结果</span>
            <span>不予受理</span>
          </div>
        </div>
        <div class="top_reject" v-if="baseList.status==150">
          <div class="no_reject">用户撤销</div>
        </div>-->
      </div>
      <!-- <div class="nav">
        <div class="nav_item" @click="goPage('1','baseInfo')">
          <p class="info" :class="{'active':index==1}">基本信息</p>
          <span class="line" v-show="index==1"></span>
        </div>
        <div class="nav_item" @click="goPage('2','stepInfo')">
          <p class="info" :class="{'active':index==2}">处置信息</p>
          <span class="line" v-show="index==2"></span>
        </div>
        <div class="nav_item" @click="goPage('3','addressInfo')">
          <p class="info" :class="{'active':index==3}">地址及物流信息</p>
          <span class="line" v-show="index==3"></span>
        </div>
      </div>-->
    </div>
    <base-info
      @confirmReceipt="confirmReceipt"
      :baselist="baseList"
      :productlist="productlist"
      :historyInfo="this.historyInfo"
      :btnlist="btnList"
      :flowid="flowId"
      :attachments="attachments"
      :addressInfo="addressInfo"
      v-if="index=='1'&&info && baseList && attachments"
      ref="baseInfo"
    ></base-info>
    <step-info :historyInfo="this.historyInfo" v-if="index=='2' && isShow ===true" ref="stepinfo"></step-info>
    <address-info :addressInfo="addressInfo" v-if="index=='3'"></address-info>
    <attention @getAttention="getAttention" ref="attention1"></attention>
    <recover :money="baseList.amount" @sendRecover="sendRecover" ref="recover1"></recover>
    <accept ref="accept" @sendAccept="sendAccept"></accept>
    <review ref="review" @sendReview="sendReview"></review>
    <!-- <BetterScroll class="bottom_nav" v-show="info.operationList" :scrollX="true"> -->
    <!-- <BetterScroll class="bottom_nav" v-show="btnList.length > 0" :scrollX="true"> -->
    <BetterScroll class="bottom_nav" v-show="bottomBoxShow()" :scrollX="true">
      <!-- <div class="nav_box">
        <span
          v-for="(item,index) in btnList"
          :key="index"
          v-show="item.select"
          class="btn"
          @click="chekInfo(item.value)"
        >{{item.type}}</span>
      </div>-->
      <!-- 非督办按钮 -->
      <div style="width: 100%;display: flex;">
        <div class="other-btns">
          <div v-if="btnList.includes('AUDIT')" @click="report()" class="btn-item">
            <img src="../../../../assets/refund/shangbao.png" alt />
            <span>上报</span>
          </div>
          <div v-if="btnList.includes('FLOW')" @click="zhuanBan" class="btn-item">
            <img src="../../../../assets/refund/zhuanban.png" alt />
            <span>转办</span>
          </div>
          <div v-if="btnList.includes('BACK_UP')" class="btn-item" @click="returnHandle">
            <img src="../../../../assets/refund/tuihui.png" alt />
            <span>退回</span>
          </div>
        </div>
        <div class="accept-btns">
          <div
            v-if="btnList.includes('NOT_HANDLED')"
            @click="inadmissible"
            class="inadmissible-btn"
          >不予受理</div>
          <div
            v-if="btnList.includes('ACCEPT')"
            @click="agreeAccept()"
            class="agree-accept-btn"
          >同意受理</div>
          <!-- <div
            v-if="btnList.includes('FEEDBACK_ADDRESS')"
            @click="chekInfo('FEEDBACK_ADDRESS')"
            class="inadmissible-btn"
          >反馈退货地址</div>-->
          <!-- <div
            v-if="btnList.includes('FEEDBACK_EXPRESS')"
            @click="chekInfo('FEEDBACK_EXPRESS')"
            class="inadmissible-btn"
          >反馈快递单号</div>-->
          <!-- <div
            v-if="btnList.includes('CONFIRM_RECEIPT')"
            @click="chekInfo('CONFIRM_RECEIPT')"
            class="inadmissible-btn"
          >确认收货</div>-->
          <div
            v-if="btnList.includes('RECOVER')"
            @click="chekInfo('RECOVER')"
            class="inadmissible-btn"
          >确认收回垫付金</div>
          <div v-if="btnList.includes('OVERSEE')" @click="supervise" class="duban-btn">督办</div>

          <div
            v-if="btnList.includes('ATTENTION')"
            @click="chekInfo('ATTENTION')"
            class="inadmissible-btn"
          >关注</div>

          <div
            v-if="btnList.includes('UN_ATTENTION')"
            @click="chekInfo('UN_ATTENTION')"
            class="inadmissible-btn"
          >取消关注</div>
          <!-- <div
            v-if="btnList.includes('FEEDBACK_VERIFY')"
            @click="chekInfo('FEEDBACK_VERIFY')"
            class="inadmissible-btn"
          >反馈验证结果</div>-->
          <!-- <div
            v-if="btnList.includes('REVIEW')"
            @click="chekInfo('REVIEW')"
            class="inadmissible-btn"
          >审核信息</div>-->
          <!-- <div
            v-if="btnList.includes('MODIFY_REFUND_METHOD')"
            @click="chekInfo('MODIFY_REFUND_METHOD')"
            class="inadmissible-btn"
          >变更退货方式</div>-->
        </div>
      </div>
      <!-- 督办按钮 -->
      <!-- <div v-if="btnList.includes('OVERSEE')" @click="supervise" class="supervise-box">
        <div class="btn">督办</div>
      </div>-->
    </BetterScroll>
  </div>
</template>
<script>
    import step from './step';
    import baseInfo from './baseInfo';
    import stepInfo from './stepInfo';
    import addressInfo from './addressInfo';
    import attention from '../../../refund/views/pages/attention';
    import recover from '../../../refund/views/pages/recover';
    import review from '../../views/pages/review';
    import accept from '../../../refund/views/pages/confirmAccept';
    import BetterScroll from '../../views/components/baseComponent/betterScroll';
    import util from '../../../../utils/common';
    import api from '../../../../service/modules/refund';
    import apimessage from '../../../../service/modules/message';
    import { Dialog } from 'vant';

    export default {
        components: {
            step,
            'base-info': baseInfo,
            'step-info': stepInfo,
            'address-info': addressInfo,
            attention,
            recover,
            review,
            accept,
            BetterScroll
        },
        data () {
            return {
                attachments: {}, // 附件，包括退货详情的图片
                title: '退货详情',
                finalRefundTypes: '3',
                isShowStep: true,
                isShow: false,
                index: 1,
                currentVal: 1,
                currentVal1: 1,
                stepArray: ['发起退货', '退货处理', '退货成功', '游客评价', '办结'],
                //  stepArray1:["发起","相应","处理","反馈","评价","完成"],
                info: '',
                baseList: '',
                historyInfo: '',
                addressInfo: '',
                id: '',
                isReject: false,
                isHide: false,
                productlist: [],
                btnList: [
                    { type: '确认收货', value: 'CONFIRM_RECEIPT', select: false },
                    { type: '收回垫付金', value: 'RECOVER', select: false },
                    { type: '关注', value: 'ATTENTION', select: false },
                    { type: '取消关注', value: 'UN_ATTENTION', select: false },
                    { type: '反馈退货地址', value: 'FEEDBACK_ADDRESS', select: false }, // 邮寄退货的同意受理
                    { type: '反馈快递单号', value: 'FEEDBACK_EXPRESS', select: false },
                    { type: '转办', value: 'FLOW', select: false },
                    { type: '同意受理', value: 'ACCEPT', select: false },
                    { type: '不予受理', value: 'NOT_HANDLED', select: false },
                    { type: '上报', value: 'AUDIT', select: false },
                    { type: '反馈验证结果', value: 'FEEDBACK_VERIFY', select: false }, // 反馈处置结果
                    { type: '审核信息', value: 'REVIEW', select: false },
                    //  {'type':'已成功收回垫付金','value':'VER','select':false},
                    //  {'type':'已审核信息','value':'Has_REVIEW','select':false},
                    { type: '变更退货方式', value: 'MODIFY_REFUND_METHOD', select: false }
                ],
                timer: null,
                flowId:
                    this.$router.currentRoute.query.flowId || util.getJsonLocal('flowId')
            };
        },
        computed: {},
        mounted () {
            // this.$store.state.refund.flowId = this.$router.currentRoute.query.flowId||util.getJsonLocal('flowId');
            this.$store.state.refund.flowId =
                this.$router.currentRoute.query.flowId || util.getJsonLocal('flowId');
            api.currentUser().then(res => {
                if (res.ret === 0) {
                    this.$store.commit('refund/getUserInfo', res.data);
                }
            });
        },
        created () {
            let messageId = this.$route.query.messageId || '';
            let isRead = this.$route.query.isRead || 'true';
            this.onMessageReadOne(isRead, messageId);
            this.getDetail();
            this.$store.dispatch('refund/setDictType')
        },
        methods: {
            // 控制底部的显示
            bottomBoxShow () {
                let flag = false
                if (this.btnList.length > 0) {
                    const arr = ['AUDIT', 'FLOW', 'BACK_UP', 'NOT_HANDLED', 'ACCEPT', 'RECOVER', 'OVERSEE']
                    for (let i = 0; i < arr.length; i++) {
                        if (this.btnList.indexOf(arr[i]) !== -1) {
                            flag = true
                            break
                        }
                    }
                }
                return flag
            },
            // 确认收货
            confirmReceipt () {
                // this.$router.go(0); // 刷新
                this.getDetail();
            },
            callPhone () {
                // this.$router.push(`/provincemaillist?code=${this.info.detail.centerId}&title=${encodeURI(this.info.detail.centerName)}`)
                window.yyn.invokeJSB(
                    'openWindow',
                    {
                        openUrl: `${
                            this.globalApp.getSystemInfo().host
                        }web/#/provincemaillist?code=${
                            this.info.detail.centerId
                        }&title=${encodeURI(this.info.detail.centerName)}`,
                        isFullScreen: 0,
                        setTitle: this.info.detail.centerName,
                        needLoading: 1
                    },
                    cb => {
                        console.log(cb, 'callback');
                    }
                );
            },
            // 消息单条已读
            onMessageReadOne (isRead, id) {
                if (isRead === 'false') {
                    apimessage.messageReadOne({ messageId: id }).then(res => {
                        localStorage.setItem('messageId', id);
                    });
                }
            },
            getDetail () {
                api.detailList({ flowId: this.flowId }).then(res => {
                    // api.detailList({ flowId: '2c288a207c30c886017c30c9b1570001' }).then(res => {
                    //   Indicator.close();
                    if (res.ret === 0) {
                        // 处理上面显示的状态
                        if (res.data.detail.statusText === '不予受理' ||
                            res.data.detail.status === 31 ||
                            res.data.detail.status === 150) {
                            this.currentVal = 6
                        } else if (res.data.detail.status === '1' || res.data.detail.status == 10 || res.data.detail.status == 11) {
                            this.currentVal = 1;
                        } else if (
                            (res.data.detail.status > 1 && res.data.detail.status < 70) ||
                            res.data.detail.status === 97
                        ) {
                            // 处理中
                            this.currentVal = 2;
                        } else if (
                            res.data.detail.status >= 70 &&
                            res.data.detail.status < 140 &&
                            !res.data.detail.paperworkEvaluation &&
                            res.data.detail.status !== 110
                        ) {
                            this.currentVal = 3;
                        } else if (
                            res.data.detail.status > 70 &&
                            res.data.detail.status < 140 &&
                            res.data.detail.paperworkEvaluation != null ||
                            res.data.detail.status === 110
                        ) {
                            this.currentVal = 4;
                        } else if (
                            res.data.detail.status === 140 ||
                            res.data.detail.status === 200
                        ) {
                            this.currentVal = 5;
                        }
                        util.setJsonLocal('detail', res.data.detail);
                        this.isShow = true;
                        this.$store.state.detailInfo = res.data.detail;
                        this.$store.state.refund.detail = res.data;
                        this.$store.state.orderNum = res.data.detail.orderNumber;
                        this.baseList = res.data.detail; // 详情
                        this.productlist = res.data.itemList;
                        this.attachments = res.data.attachments;
                        // this.$set(this.baseList, 'status', '150');
                        // this.$set(this.baseList, 'statusText', '');
                        this.historyInfo = res.data.history;
                        this.addressInfo = res.data.expressList;
                        this.info = res.data;
                        if (res.data.detail.finalRefundTypes) {
                            this.finalRefundTypes = this.baseList.finalRefundTypes;
                            this.title1 = '变更退货方式';
                        }
                        // this.$refs.baseInfo.getImg(res.data.detail.orderNumber);
                        // this.$refs.baseInfo.shopCity(res.data.detail.shoppingCityId);
                        if (res.data.operationList !== null) {
                            this.btnList = res.data.operationList;
                            // res.data.operationList.map((item, index) => {
                            //   this.btnList.map((item1, index1) => {
                            //     if (item1.value === item) {
                            //       this.$set(this.btnList[index1], "select", true);
                            //     }
                            //   });
                            // });
                        } else {
                            this.btnList = [];
                        }
                    }
                });
            },
            // 退回
            returnHandle () {
                try {
                    this.$router.push({
                        path: '/refund/sendBack',
                        query: {
                            flowId: this.flowId
                        }
                    });
                } catch (err) {
                    console.log(err);
                }
            },
            // 督办
            supervise () {
                this.$router.push({
                    path: '/refund/supervise',
                    query: {
                        data: this.baseList
                    }
                });
                // const param = {
                //   refundOrderId: this.baseList.basicId
                // }
                // api.supervise(param).then(res => {
                //   if (res.ret === 0) {
                //     this.$Toast({
                //       message: res.msg
                //     });
                //   }
                // });
            },
            // 二期同意受理操作
            agreeAccept () {
                this.$router.push({
                    path: '/refund/agreeAccept',
                    query: {
                        number: this.baseList.orderNumber,
                        flowId: this.flowId,
                        data: this.baseList
                    }
                });
            },
            // 上报按钮
            report () {
                this.$router.push({
                    path: '/refund/audit',
                    query: {
                        number: this.baseList.orderNumber,
                        flowId: this.flowId
                    }
                });
            },
            // 不予受理
            inadmissible () {
                this.$router.push({
                    path: '/refund/noHandel',
                    query: {
                        number: this.baseList.orderNumber,
                        flowId: this.flowId,
                        data: this.baseList
                    }
                });
            },
            // 转办
            zhuanBan () {
                this.$router.push({
                    path: '/refund/flow',
                    query: {
                        number: this.baseList.orderNumber,
                        flowId: this.flowId
                    }
                });
            },
            goPage (index, page) {
                this.index = index;
                window.scrollTo(0, 0); // 回到顶部
            },
            chekInfo (value) {
                if (value === 'NOT_HANDLED') {
                    this.$router.push(
                        'noHandel?number=' +
                            this.baseList.orderNumber +
                            '&flowId=' +
                            this.flowId
                    );
                } else if (value === 'ACCEPT') {
                    this.$router.push(
                        'accpet?number=' +
                            this.baseList.orderNumber +
                            '&flowId=' +
                            this.flowId +
                            '&finalRefundTypes=' +
                            this.finalRefundTypes
                    );
                } else if (value === 'FEEDBACK_ADDRESS') {
                    this.$router.push(
                        'feebackExpress?number=' +
                            this.baseList.orderNumber +
                            '&flowId=' +
                            this.flowId
                    );
                } else if (value === 'FLOW') {
                    this.$router.push(
                        'flow?number=' + this.baseList.orderNumber + '&flowId=' + this.flowId
                    );
                } else if (value === 'AUDIT') {
                    this.$router.push(
                        'audit?number=' + this.baseList.orderNumber + '&flowId=' + this.flowId
                    );
                } else if (value === 'FEEDBACK_EXPRESS') {
                    this.$router.push(
                        'express?number=' +
                            this.baseList.orderNumber +
                            '&flowId=' +
                            this.flowId
                    );
                } else if (value === 'FEEDBACK_VERIFY') {
                    this.$router.push(
                        'feedReulst?number=' +
                            this.baseList.orderNumber +
                            '&flowId=' +
                            this.flowId +
                            '&&price=' +
                            this.baseList.shoppingAmount
                    );
                } else if (value === 'ATTENTION') {
                    // 关注
                    // this.$refs.attention1.showBox();
                    this.getAttention();
                } else if (value === 'RECOVER') {
                    Dialog.confirm({
                        title: '是否收回垫付金',
                        message: `垫付金¥${this.baseList.amount}`,
                        confirmButtonColor: '#36B374'
                    }).then(() => {
                        this.sendRecover()
                        // on close
                    })
                    // this.$refs.recover1.showBox();
                } else if (value === 'CONFIRM_RECEIPT') {
                    this.$refs.accept.showBox();
                } else if (value === 'UN_ATTENTION') {
                    this.getUnAttention();
                } else if (value === 'VER') {
                    this.$Toast({
                        message: '你已成功收回垫付金了~'
                    });
                } else if (value === 'REVIEW') {
                    // 审核
                    this.$refs.review.showBox();
                } else if (value === 'Has_REVIEW') {
                    // 审核
                    this.$Toast({
                        message: '你已经审核过了~'
                    });
                } else if (value === 'MODIFY_REFUND_METHOD') {
                    // 变更退货方式
                    this.$router.push(
                        'accpet?number=' +
                            this.baseList.orderNumber +
                            '&flowId=' +
                            this.flowId +
                            '&finalRefundTypes=' +
                            this.finalRefundTypes
                    );
                }
            },
            getAttention () {
                // 关注
                api.attention({ flowId: this.baseList.flowId }).then(res => {
                    if (res.ret === 0) {
                        this.$Toast({
                            message: '关注成功'
                        });
                        // this.$set(this.btnList[2], "select", false);
                        // this.$set(this.btnList[3], "select", true);
                        this.getDetail();
                    }
                });
            },
            getUnAttention () {
                // 取消关注
                api.unAttention({ flowId: this.baseList.flowId }).then(res => {
                    if (res.ret === 0) {
                        this.$Toast({
                            message: '已成功取消关注'
                        });
                        // this.$set(this.btnList[2], 'select', true);
                        // this.$set(this.btnList[3], 'select', false);
                        this.getDetail();
                    }
                });
            },
            sendRecover () {
                // 收回垫付金
                api.recover({ flowId: this.baseList.flowId }).then(res => {
                    if (res.ret === 0) {
                        this.$Toast({
                            message: res.msg
                        });
                        // this.$set(this.btnList[1], "select", false);
                        this.getDetail();
                        // this.$router.go(0);
                        //    this.$set(this.btnList[1],'select',false);
                        //    this.$set(this.btnList[12],'select',true);
                    }
                });
            },
            sendAccept () {
                // 确认收货
                api.confirmReceipt({ flowId: this.baseList.flowId }).then(res => {
                    if (res.ret === 0) {
                        this.$Toast({
                            message: res.msg
                        });
                        this.$set(this.btnList[0], 'select', false);
                        this.getDetail();
                    } else {
                        this.$Toast({
                            message: res.msg
                        });
                    }
                });
            },
            sendReview () {
                // 审核通过
                api
                    .audit({ flowId: this.baseList.flowId, status: '22', content: '' })
                    .then(res => {
                        if (res.ret === 0) {
                            this.$set(this.btnList[11], 'select', false);
                            this.$Toast({
                                message: res.msg
                            });
                            this.getDetail();
                        }
                    });
            },
            refoundOrder (value) {},
            beforeRouteLeave (to, from, next) {
                console.log('我离开了');
            }
        }
    };
</script>
<style scoped lang="less">
.container {
  width: 100%;
  // background-color: @base-background;
  background-color: #F8F9Fc;
  .top_box {
    width: 100%;
    // position: fixed;
    left: 0;
    top: 0px;
    z-index: 2;
    .top_title {
      width: 100%;
      height: 146px;
      background-color: @base-color;
      position: relative;
      .top_one {
        width: 100%;
        // height:100%;
        .tip_tool {
          width: 220px;
          // padding:0 10px;
          height: 42px;
          background-color: #2e9963;
          text-align: center;
          line-height: 42px;
          position: relative;
          top: 8px;
          left: 14px;
          font-size: 12px;
          text-align: center;
          border-radius: 2px;
          span {
            padding: 0 6px;
            box-sizing: border-box;
            display: inline-block;
            width: 100%;
            height: 42px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            opacity: 1;
            color: #fff;
            i {
              display: inline;
              vertical-align: middle;
            }
            .icon_person {
              display: inline-block;
              vertical-align: middle;
              width: 12px;
              height: 13px;
              margin-right: 6px;
              margin-top: -2px;
            }
          }
        }
        .tip_one {
          left: 14px !important;
        }
        .tip_two {
          left: 85px !important;
        }
        .tip_three {
          left: 221px;
          transform: translateX(-50%);
        }
        .tip_four {
          left: 172px;
        }
        .tip_five {
          left: 130px;
        }
        .tip_six {
          left: 138px;
        }
        .tip_seven {
          left: 198px;
        }
        .jiao {
          position: absolute;
          left: 8px;
          top: -23px;
          width: 14px;
          height: 14px;
          border-top: 14px solid transparent;
          border-right: 14px solid transparent;
          border-bottom: 14px solid #2e9963;
          border-left: 14px solid transparent;
        }
        .jiao_active1 {
          left: 62px;
        }
        .jiao_active2 {
          left: 136px;
        }
        // .jiao_active2{
        //     left:64px;
        // }
        .jiao_active3 {
          left: 190px;
        }
        .jiao_active5 {
          left: 220px;
        }
      }
      .top_reject {
        width: 100%;
        height: 126px;
        padding: 0 15px;
        box-sizing: border-box;
        .reject_one {
          height: 62px;
          line-height: 62px;
          width: 100%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          color: #fff;
          span {
            font-size: 15px;
          }
          span:nth-child(1) {
            color: #fff;
            opacity: 0.6;
          }
          span:nth-child(2) {
            color: #fff;
            margin-left: 20px;
          }
        }
        .no_reject {
          width: 100%;
          height: 126px;
          text-align: center;
          line-height: 126px;
          font-size: 20px;
          color: #fff;
          text-align: left;
        }
      }
      // .step{
      //     padding:10px 22px;
      //     .step_item{
      //         width:23%;
      //         height:30px;
      //         display: inline-block;
      //         // background: pink;
      //         position: relative;
      //         font-size:0;
      //         border-top:1px solid #81A0C7;
      //         .col{
      //             display: inline-block;
      //             width:10px;
      //             height:10px;
      //             border-radius: 50%;
      //             background-color:#81A0C7;
      //             position: absolute;
      //             left:-5px;
      //             top:-5px;
      //         }
      //         .text{
      //             font-size:13px;
      //             color:#81A0C7;
      //             position: absolute;
      //             left:0;
      //             bottom:0;
      //             transform: translate(-50%,50%);
      //         }
      //         .col1{
      //             display: inline-block;
      //             width:10px;
      //             height:10px;
      //             border-radius: 50%;
      //             background-color:#81A0C7;
      //             position: absolute;
      //             right:-5px;
      //             top:-5px;
      //         }
      //         .text1{
      //             font-size:13px;
      //             color:#81A0C7;
      //             position: absolute;
      //             right:0;
      //             bottom:0;
      //             transform: translate(50%,50%);
      //         }
      //     }
      // }
    }
    .nav {
      width: 100%;
      height: 50px;
      background-color: #fafafa;
      box-sizing: border-box;
      padding: 0 12px;
      .nav_item {
        height: 100%;
        text-align: center;
        display: inline-block;
        position: relative;
        margin-right: 24px;
        .info {
          margin-top: 24px;
          font-size: 14px;
          color: #666;
        }
        .active {
          font-size: 14px;
          font-weight: 700;
          color: #36b374;
        }
        .line {
          display: inline-block;
          position: absolute;
          width: 100%;
          height: 2px;
          background-color: @base-color;
          left: 50%;
          margin-top: 4px;
          transform: translateX(-50%);
          -webkit-transform: translateX(-50%);
        }
      }
    }
  }
  .animate_active {
    animation: changehide 1s ease-out forwards;
  }
  .animate_active1 {
    animation: changehide1 1s ease-out backwards;
  }

  @keyframes changehide {
    0% {
      opacity: 1;
      right: 0;
    }
    100% {
      opacity: 0.4;
      right: -35px;
    }
  }
  @-webkit-keyframes changehide {
    0% {
      opacity: 1;
      right: 0;
    }
    100% {
      opacity: 0.4;
      right: -35px;
    }
  }
  @keyframes changehide1 {
    0% {
      opacity: 1;
      right: 0;
    }
    100% {
      opacity: 0.4;
      right: -35px;
    }
  }
  @-webkit-keyframes changehid1 {
    0% {
      opacity: 0.8;
      right: -35px;
    }
    100% {
      opacity: 1;
      right: 0;
    }
  }
  .go_home {
    position: fixed;
    right: 0;
    top: 530px;
    width: 59px;
    height: 59px;
    background-color: #e4f5ff;
    padding: 9px 10px 9px 9px;
    border-radius: 29px 0 0 29px;
    z-index: 10;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .bottom_nav {
    width: 100%;
    // height: 50px;
    padding: 12px 0;
    padding-bottom: 20px;
    position: fixed;
    left: 0;
    bottom: 0px;
    background-color: #fff;
    box-shadow: 0px 5px 20px 5px rgba(0, 0, 0, 0.04);
    display: flex;
    align-items: center;
    justify-content: space-between;
    // z-index: 4;
    .other-btns {
      display: flex;
      justify-content: space-evenly;
      flex: 1;

      .btn-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 14px;
          height: 14px;
          margin-bottom: 9px;
        }
        span {
          font-size: 12px;
          color: #71747a;
        }
      }
    }
    .accept-btns {
      display: flex;
      .inadmissible-btn {
        border: 1px solid #36b374;
        border-radius: 2px;
        font-size: 16px;
        color: #36b374;
        padding: 0 20px;
        line-height: 36px;
        margin-right: 8px;
        font-weight: 500;
      }
      .duban-btn {
        border-radius: 2px;
        border: 1px solid #36b374;
        padding: 0 19px 0 21px;
        line-height: 36px;
        font-size: 16px;
        color: #36b374;
        font-weight: 500;
        margin-right: 16px;
      }
      .agree-accept-btn {
        background: #36b374;
        border-radius: 2px;
        font-size: 14px;
        color: #ffffff;
        text-align: center;
        padding: 0 20px;
        margin-right: 16px;
        line-height: 38px;
      }
    }
    .supervise-box {
      padding: 8px 16px;
      width: 100%;
      .btn {
        color: white;
        background: #36b374;
        border-radius: 4px;
        text-align: center;
        padding: 12px 0;
      }
    }

    .nav_box {
      position: absolute;
      white-space: nowrap;
      font-size: 0;
      .btn {
        padding: 8px 8px 7px 8px;
        display: inline-block;
        text-align: center;
        // height: 30px;
        // line-height: 30px;
        font-size: 14px;
        color: #fff;
        border-radius: 2px;
        border: 1px solid @base-color;
        color: @base-color;
        margin-left: 12px;
        margin-right: 4px;
      }
    }
  }
}
</style>
